import { useEffect } from "react";
import { isNil, isEmpty } from "ramda";
import { useLocalStorage } from "react-use";
import { styled } from "@mui/material/styles";

import { useUsers } from "hooks";
import { externalRoutes } from "routes";
import UserPresenter from "presenters/UserPresenter";
import LocationInfoRepository from "repositories/LocationInfoRepository";

const NotSellMyDataLinkContainer = styled("div")(({ theme }) => ({
  textAlign: "center",
  padding: "34px 32px 0 32px",
  fontSize: theme.typography.caption.fontSize,
  [theme.breakpoints.up("mobile")]: {
    padding: "32px 140px 0 140px",
  },
  [theme.breakpoints.up("tablet")]: {
    padding: "43px 168px 0 168px",
    fontSize: theme.typography.caption.fontSize,
  },
  "& a": {
    textDecoration: "underline",
  },
}));

const NotSellMyDataLink = () => {
  const { currentUser } = useUsers();
  const [locationInfo, setLocationInfo] = useLocalStorage("userLocationInfo", {});
  const listStates = {
    US: ["CA", "CO", "UT", "CT", "OR", "TX", "MT"],
  };
  const listCountries = [
    "AT",
    "BE",
    "BG",
    "HR",
    "CY",
    "CZ",
    "DK",
    "EE",
    "FI",
    "FR",
    "DE",
    "GR",
    "HU",
    "IE",
    "IT",
    "LV",
    "LT",
    "LU",
    "MT",
    "NL",
    "PL",
    "PT",
    "RO",
    "SK",
    "SI",
    "ES",
    "SE",
    "IS",
    "LI",
    "NO",
    "CH",
    "GB",
  ];

  const showNotSellMyData = (location) => {
    if (isNil(location?.country)) return false;

    if (location.country === "US" && listStates.US.includes(location.subdivision)) return true;

    if (listCountries.includes(location.country)) return true;

    return false;
  };

  useEffect(() => {
    if (isEmpty(locationInfo)) {
      LocationInfoRepository.get().then((data) => {
        setLocationInfo(data.data);
      });
    }
  }, []);

  return showNotSellMyData(locationInfo) ? (
    <NotSellMyDataLinkContainer>
      <a
        href={
          UserPresenter.isRegistered(currentUser)
            ? externalRoutes.notSellMyDataLinkPath(currentUser.email)
            : externalRoutes.notSellMyDataLinkPath()
        }
        target="_blank"
        rel="noreferrer"
      >
        Do Not Sell or Share My Data
      </a>
    </NotSellMyDataLinkContainer>
  ) : (
    <></>
  );
};

export default NotSellMyDataLink;
